module.exports = __webpack_public_path__ + "img/82200.5f320c16.jpg";